import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { ReportStatus } from "src/app/constants/report-status";

import { Report } from "src/app/models/reports";
import { AgentCRMService } from "src/app/services/agent-crm.service";
import { HelperService } from "src/app/services/helper.service";

@Component({
    selector: 'mwp-reports-history',
    templateUrl: './reports-history.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReportsHistoryComponent implements OnInit {
    public reports: Report[];

    constructor(
        private agentCRMService: AgentCRMService,
        private helperService: HelperService,
    ) {
    }

    ngOnInit(): void {
        this.buildReports();
    }

    public deleteReport(report: Report): void {
        this.agentCRMService.deleteReport(report).subscribe(() => {
            this.buildReports();
        });
    }

    private buildReports(): void {
        this.agentCRMService.getReportHistory().subscribe((respone: Report[]) => {
            this.reports = respone;
            this.reports.forEach((r: Report) => {
                r.status = this.helperService.getTypeOfValue(ReportStatus, r.status);
            });
        });
    }
}